"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDoesStringOnlyContainSpaces;

function getDoesStringOnlyContainSpaces(name) {
  return !!name.length && !name.trim().length;
}

module.exports = exports.default;